import { connect } from "react-redux";
import AlertsApp from "../components/AlertsApp";
import { dismissAlert } from "../actions";
var mapStateToProps = function(state, _ownProps) {
    return {
        history: state.alerts.history,
        currentAlert: state.alerts.currentAlert
    };
};
var mapDispatchToProps = function(dispatch, _ownProps) {
    return {
        dismissAlert: function() {
            dispatch(dismissAlert());
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(AlertsApp);
